import React, { useEffect, useState, useRef } from "react";
import DateRange from "../../Component/DateRange/DateRange";
import { Toast } from "../../Component/Toast";
import { get } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import useStore from "../../LocalStore/useStore";
import CustomScroll from "../../Component/CustomScroll";
import { useLocation, useNavigate } from "react-router-dom";

const Notifications = () => {

  const { kv, set } = useStore();
  const notification = kv.notification || {
    today: [],
    yesterday: [],
    others: {},
  };

  const location = useLocation();
  const scrollRef = useRef(null);

  useEffect(() => {
    const fromFooter = location.state?.fromFooter;

    if (fromFooter) {
      if (location.state?.fromFooter) {
        setTimeout(() => {
          if (scrollRef.current) {
            scrollRef.current.scrollTo({ top: 0, behavior: 'smooth' });
          }
        }, 0);
        getList();
      }
    }
  }, [location]);

  const [groupedData, setGroupedData] = useState(notification);

  const formatDate = (dateStr) => {
    const parts = dateStr.split(" ");
    return parts[0]; // return YYYY-MM-DD
  };

  const groupNotifications = (list) => {
    const todayDate = new Date().toISOString().split("T")[0];

    const yesterdayDateObj = new Date();
    yesterdayDateObj.setDate(yesterdayDateObj.getDate() - 1);
    const yesterdayDate = yesterdayDateObj.toISOString().split("T")[0];

    let todayArr = [];
    let yesterdayArr = [];
    let otherGroups = {};

    list.forEach((item) => {
      const dateOnly = formatDate(item.created_at);

      if (dateOnly === todayDate) {
        todayArr.push(item);
      } else if (dateOnly === yesterdayDate) {
        yesterdayArr.push(item);
      } else {
        if (!otherGroups[dateOnly]) {
          otherGroups[dateOnly] = [];
        }
        otherGroups[dateOnly].push(item);
      }
    });

    setGroupedData({
      today: todayArr,
      yesterday: yesterdayArr,
      others: otherGroups,
    });
    set("notification", {
      today: todayArr,
      yesterday: yesterdayArr,
      others: otherGroups,
    });
  };

  const getList = async () => {
    try {
      const res = await get(`${URLS.NOTIFICATION}`);
      // // console.log("res notification get", res);

      if (res?.status === "success" && Array.isArray(res?.data)) {
        groupNotifications(res?.data);
      }
    } catch (err) {
      Toast("Failed to load history");
    }
  };

  useEffect(() => {
    getList();
  }, []);

  // // console.log("groupedData", groupedData);

  const getOnlyTime = (dateTimeStr) => {
    if (!dateTimeStr) return "";
    const parts = dateTimeStr.split(" ");
    return parts.slice(1).join(" ");
  };

  const formatDisplayDate = (dateStr) => {
    const [year, month, day] = dateStr.split("-");
    return `${day}-${month}-${year}`;
  };

  const navigate = useNavigate();

  const handleNotificationAction = (type) => {
    let screenName = "";

    switch (type) {
      case "Winning Number Announcement":
        screenName = "/daily-result";
        break;
      case "Winning Declaration":
        screenName = "/winning-history";
        break;
      case "Account Details Removed!":
        screenName = "/wallet";
        break;
      case "Commission Amount Received":
        screenName = "/refer-friends";
        break;
      case "Amount Credited to BANK":
        screenName = "/withdraw";
        break;
      case "Recharge Successful":
        screenName = "/recharge-history";
        break;
      default:
        // // console.log("⚠️ Unknown notification type:", type);
        return;
    }

    navigate(screenName);
  };



  return (
    <div className="dashRightView-foots">
      <CustomScroll ref={scrollRef}>
        <div style={{ marginBottom: 30 }} className=" container_overalls">
          {groupedData?.today?.length > 0 && (
            <div className=" ">
              <p className="f3 fs-xs-17 fs-sm-16 fs-md-18 fs-lg-20 fs-xl-22 fs-xxl-24 primary">
                Today
              </p>
              {groupedData?.today?.map((item, ind) => {
                return (
                  <div onClick={() => handleNotificationAction(item?.title)} className="calender-input-daily mt-2 p-3" key={ind}>
                    <h1 style={{ fontSize: 16 }} className="f4 fs-sm-16">{item?.title}</h1>
                    <p className="f2 fs-xs-14 messageTxc fs-sm-16 fs-md-18 fs-lg-20 fs-xl-22 fs-xxl-24 ">
                      {item?.message}{" "}
                    </p>
                    <div className="d-flex ac-je mt-2">
                      <p className="f2 fs-xs-14 fs-sm-16 fs-md-18 fs-lg-20 fs-xl-22 fs-xxl-24 gray">
                        {getOnlyTime(item?.created_at)}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
          {groupedData?.yesterday?.length > 0 && (
            <div className="  ">
              <p className="f3 mt-2 mb-1 fs-xs-17 fs-sm-16 fs-md-18 fs-lg-20 fs-xl-22 fs-xxl-24 primary">
                Yesterday
              </p>
              {groupedData?.yesterday?.map((item, ind) => {
                return (
                  <div onClick={() => handleNotificationAction(item?.title)} className="calender-input-daily  mb-4  p-3" key={ind}>
                    <h1 style={{ fontSize: 16 }} className="f4 fs-sm-16">{item?.title}</h1>
                    <p className="f2 fs-xs-14 messageTxc fs-sm-16 fs-md-18 fs-lg-20 fs-xl-22 fs-xxl-24 ">
                      {item?.message}{" "}
                    </p>
                    <div className="d-flex ac-je">
                      <p className="f2 fs-xs-14 fs-sm-16 fs-md-18 fs-lg-20 fs-xl-22 fs-xxl-24 gray">
                        {getOnlyTime(item?.created_at)}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          )}

          {Object.keys(groupedData?.others)?.map((date, ind) => {
            return (
              <div className="  " key={ind}>
                <p className="f3 mt-4 mb-1 fs-xs-17 fs-sm-16 fs-md-18 fs-lg-20 fs-xl-22 fs-xxl-24 primary">
                  {formatDisplayDate(date)}
                </p>
                {groupedData?.others?.[date]?.map((item, subInd) => {
                  return (
                    <div onClick={() => handleNotificationAction(item?.title)} className="calender-input-daily mb-4 p-3" key={subInd}>
                      <h1 style={{ fontSize: 16 }} className="f4 fs-sm-16">{item?.title}</h1>
                      <p className="f2 fs-xs-14 fs-sm-16 fs-md-18 messageTxc fs-lg-20 fs-xl-22 fs-xxl-24 ">
                        {item?.message}{" "}
                      </p>
                      <div className="d-flex ac-je mt-4">
                        <p className="f2 fs-xs-14 fs-sm-16 fs-md-18 fs-lg-20 fs-xl-22 fs-xxl-24 gray">
                          {getOnlyTime(item?.created_at)}
                        </p>
                      </div>
                    </div>
                  );
                })}
              </div>
            );
          })}

          {groupedData.today.length === 0 &&
            groupedData.yesterday.length === 0 &&
            Object.keys(groupedData.others).length === 0 && (
              <div className="   mt-3">
                <p className="f3 text-center fs-xs-17 fs-sm-16 fs-md-18 fs-lg-20 fs-xl-22 fs-xxl-24 primary">
                  No data
                </p>
              </div>
            )}
        </div>
      </CustomScroll>
    </div>
  );
};
export default Notifications;
